import "./SatDesignerBottomBarModals.css";
import { useEffect, useState } from "react";
import { MinimizeIcon, CloseModalIcon, DividerLine } from "../../SatelliteProfileImgAssets/SatelliteProfileImgAssets";
import SatelliteProfileModalDropdown from "../SatelliteProfileModalDropdown";
import { containsSpecialChars, getCharacterLimitMessage, getSpecialCharacterMessage, onKeyDown, showToastMessage, validateAngleRange, validateInputRange, validateNumberWithoutDecimal } from "../../../../../../utils/commonFunctions";
import { VALIDATION_RULES } from "../../../../../../utils/constants";


const SatDesignerBottomBarModal = ({ controlModeModalProps, addControlMode, updateControlMode, prevControlmode, setIsModalMinimized, isModalMinimized, setHeaderObject, headerObject, isValueUpdate, setIsValueUpdate}) => {
  
  // Expand the Add Control Modal if minimized
  const expandModal = () => {
    if (isModalMinimized) setIsModalMinimized(false);
  }

  const CustomModelModalHeader = ({ headerProps }) => (
    <div className={`customModelModalHeader ${!isModalMinimized ? 'with-border' : ''}`}
      onClick={() => {
        expandModal() 
      }}
    >
      <div className="customModelModalHeaderTitle"
        onClick={(e) => {
          e.stopPropagation()
          expandModal()

        }}
      >
        {headerProps.title}
      </div>
      <div className="customModelModalHeaderIcons">
        <button onClick={() => setIsModalMinimized(!isModalMinimized)}>
          <MinimizeIcon />
        </button>
        <button
          onClick={() => {
            controlModeModalProps.setIsAddControlModeModal(false);
          }}
        >
          <CloseModalIcon />
        </button>
      </div>
    </div>
  );

  const [rollInput, setRollInput] = useState({ name: "Roll", value: "0", unit: "deg" });
  const [pitchInput, setPitchInput] = useState({ name: "Pitch", value: "0", unit: "deg" });
  const [yawInput, setYawInput] = useState({ name: "Yaw", value: "0", unit: "deg" });

  const [orientation, setOrientation] = useState<{ x: number | string; y: number | string; z: number | string }>({ x: 0, y: 0, z: 0 });

  const pointingEntities = [
    { label: "Sun", value: "Sun" },
  ];
  const handleSelectedPointingEntity = (e) => {
  };
  const [isPreviousSelected, setIsPreviousSelected] = useState("Sun");

  // const [isModalMinimized, setIsModalMinimized] = useState(false);
  // const [headerObject, setHeaderObject] = useState({ title: prevControlmode ? "Edit Control Mode" : "Add Control Mode", isModalMinimized: isModalMinimized, setIsModalMinimized: setIsModalMinimized });
  // const [isValueUpdate, setIsValueUpdate] = useState(false)

  const [isVector, setIsVector] = useState(false);
  const [name, setName] = useState("");
  const [prevName, setPrevName] = useState()

  const addingControlMode = () => {
    if (!name) {
      showToastMessage('error', 'Please Enter Control Mode Name')
      return;
    }
    let orientations = isVector
      ? [orientation.x, orientation.y, orientation.z]
      : [parseFloat(rollInput.value), parseFloat(pitchInput.value), parseFloat(yawInput.value)];
    const body = {
      name: name,
      attitude: !isVector,
      editable: true,
      orientation: orientations,
    };

    if (prevControlmode) {
      updateControlMode(body, prevName)
    }
    else {
      addControlMode(body);
    }
  }

  useEffect(() => {
    if (prevControlmode) {
      setName(prevControlmode?.name)
      setPrevName(prevControlmode?.name)
      setIsVector(!prevControlmode?.attitude)

      if (prevControlmode?.attitude) {
        setRollInput({
          ...rollInput,
          value: prevControlmode?.orientation?.[0]
        })
        setPitchInput({
          ...pitchInput,
          value: prevControlmode?.orientation?.[1]
        })
        setYawInput({
          ...yawInput,
          value: prevControlmode?.orientation?.[2]
        }
        )
      }else {
        setOrientation({ x: prevControlmode?.orientation?.[0], y: prevControlmode?.orientation?.[1], z: prevControlmode?.orientation?.[2] })
      }
    }else {
      setName("")
      setIsVector(false)
      setRollInput({
        ...rollInput,
        value: '0'
      })
      setPitchInput({
        ...pitchInput,
        value: '0'
      })
      setYawInput({
        ...yawInput,
        value: '0'
      }
      )
      setOrientation({x: 0,y: 0, z: 0 })
    }
  }, [prevControlmode])

  const validateAndSetOrientationData = (value, axis) => {
    setIsValueUpdate(true)
    // Allow intermediate states like "-" or "."
    if (value === '' || value === '-' || value === '.' || value === '-.') {
      setOrientation((prev) => ({ ...prev, [axis]: value }));
      return;
    }
    if (value.length > 9) {
      showToastMessage('error', getCharacterLimitMessage(9));
      return;
    }
    const numericValue = value;
    if (!isNaN(numericValue)) {
      const { MIN, MAX } = VALIDATION_RULES.ORIENTATION_RANGE;
      const validation = validateAngleRange(numericValue, MIN, MAX);
      if (validation.success) {
        setOrientation((prev) => ({ ...prev, [axis]: parseFloat(numericValue) }));
      } else {
        showToastMessage('info', `The value must be between ${MIN} and ${MAX}`);
      }
    } else {
      setOrientation((prev) => ({ ...prev, [axis]: value }));
    }
  };

  // checking the empty values in Roll, Pitch and Yaw and if empty then setting the default value as 0
  const checkEmptyRollPitchYawValues = (step) => {
    switch (step) {
      case "RollInput":
        if (pitchInput.value === "") {
          setPitchInput({
            ...pitchInput,
            value: "0",
          });
        }
        if (yawInput.value === "") {
          setYawInput({
            ...yawInput,
            value: "0",
          });
        }
        break;
      case "PitchInput":
        if (rollInput.value === "") {
          setRollInput({
            ...rollInput,
            value: "0",
          });
        }
        if (yawInput.value === "") {
          setYawInput({
            ...yawInput,
            value: "0",
          });
        }
        break;
      case "YawInput":
        if (pitchInput.value === "") {
          setPitchInput({
            ...pitchInput,
            value: "0",
          });
        }
        if (rollInput.value === "") {
          setRollInput({
            ...rollInput,
            value: "0",
          });
        }
        break;
      case "other":
        if (rollInput.value === "") {
          setRollInput({
            ...rollInput,
            value: "0",
          });
        }
        if (pitchInput.value === "") {
          setPitchInput({
            ...pitchInput,
            value: "0",
          });
        }
        if (yawInput.value === "") {
          setYawInput({
            ...yawInput,
            value: "0",
          });
        }
        break;
    }
    return;
  }

  const checkIfPointingVectorIsEmpty = (axis) => {
    switch (axis) {
      case "x":
        if (orientation.y === "") {
          setOrientation((prev) => ({ ...prev, ['y']: '0' }));
        }
        if (orientation.z === "") {
          setOrientation((prev) => ({ ...prev, ['z']: '0' }));
        }
        break;
      case "y":
        if (orientation.x === "") {
          setOrientation((prev) => ({ ...prev, ['x']: '0' }));
        }
        if (orientation.z === "") {
          setOrientation((prev) => ({ ...prev, ['z']: '0' }));
        }
        break;
      case "z":
        if (orientation.x === "") {
          setOrientation((prev) => ({ ...prev, ['x']: '0' }));
        }
        if (orientation.y === "") {
          setOrientation((prev) => ({ ...prev, ['y']: '0' }));
        }
        
        break;
      case "other":
        if (orientation.x === "") {
          setOrientation((prev) => ({ ...prev, ['x']: '0' }));
        }
        if (orientation.y === "") {
          setOrientation((prev) => ({ ...prev, ['y']: '0' }));
        }
        if (orientation.z === "") {
          setOrientation((prev) => ({ ...prev, ['z']: '0' }));
        }
        break;
    }
    return;

  }

  const validateControlModeName = (inputCMValue) => {
    setIsValueUpdate(true)
    const isNotValidName = containsSpecialChars(inputCMValue)
    if (isNotValidName) {
      showToastMessage('error', getSpecialCharacterMessage())
    } else {
      if (inputCMValue.length > 26) {
        showToastMessage('error', getCharacterLimitMessage(26))
      } else {
        setName(inputCMValue.trimStart());
      }
    }
  }

  const validateAndSetRPYInput = (inputValue, inputType) => {
    setIsValueUpdate(true)
    if (inputValue.length > 9) {
      showToastMessage('error', getCharacterLimitMessage(9))
    } else {
      const validation = validateAngleRange(inputValue, VALIDATION_RULES.ANGLE_RANGE.MIN, VALIDATION_RULES.ANGLE_RANGE.MAX);
      if (validation.success) {
        if (inputType === "RollInput") {
          setRollInput({
            ...rollInput,
            value: inputValue,
          });
        }
        else if (inputType === "PitchInput") {
          setPitchInput({
            ...pitchInput,
            value: inputValue,
          });
        }
        else if (inputType === "YawInput") {
          setYawInput({
            ...yawInput,
            value: inputValue,
          });
        }
      }
      else {
        showToastMessage('info', `The value must be between ${VALIDATION_RULES.ANGLE_RANGE.MIN}° and ${VALIDATION_RULES.ANGLE_RANGE.MAX}°`)
      }
    }

  }
  
  return (
    <>
      <div className="customModelControlModeModal">
        <CustomModelModalHeader headerProps={headerObject} />
        {!isModalMinimized && (
          <div className="customModelModalBody">
            {/* Name of control mode input */}
            <div className="infocard-component-properties-div">
              <div className="infocard-component-properties-sub-div">
                <span className="infocard-units-location-span mode_name">Mode Name</span>
                <div className="infocard-units-location-sub-div">
                  <input
                    className="infocard-input-long-type"
                    type="text"
                    placeholder="CM Name"
                    value={name}
                    onChange={(e) => {
                      e.preventDefault()
                      validateControlModeName(e.target.value)
                    }}
                  ></input>
                </div>
              </div>
            </div>
            <div className="greenModalFooter"></div>
            <div className="infocard-component-properties-div">
              <div className="infocard-component-properties-sub-div">
                <button className={`infocard-component-type-selector-div ${!isVector ? "active" : ""} `} 
                  disabled={prevControlmode && prevControlmode?.attitude === false}
                  onClick={() => {
                    checkIfPointingVectorIsEmpty("other")
                    setIsVector(false)
                  }}>
                  Attitude
                </button>
                <button className={`infocard-component-type-selector-div ${isVector ? "active" : ""} `} 
                  disabled={prevControlmode && prevControlmode?.attitude === true}
                  onClick={() => {
                    checkEmptyRollPitchYawValues("other")
                    setIsVector(true)
                  }}>
                  Vector
                </button>
              </div>
            </div>

            {!isVector && (
              <>
                <div className="infocard-component-properties-div">
                  <div className="infocard-component-properties-sub-div">
                    <span className="infocard-units-location-span">{rollInput?.name}</span>
                    <div className="infocard-units-location-sub-div">
                      <div className="infocard-component-togglebtn-div">
                        <div className="infocard-component-value-div">
                          <input
                            className="infocard-location-value text-truncate"
                            type="number"
                            value={rollInput?.value}
                            title={rollInput?.value}
                            onKeyDown={onKeyDown}
                            onChange={(e) => {
                              checkEmptyRollPitchYawValues("RollInput");
                              validateAndSetRPYInput(e.target.value, "RollInput")
                            }}
                          ></input>
                        </div>
                        <div className="infocard-component-units-div">
                          <span className="infocard-location-y-axis">{rollInput?.unit}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="infocard-component-properties-div">
                  <div className="infocard-component-properties-sub-div">
                    <span className="infocard-units-location-span">{pitchInput?.name}</span>
                    <div className="infocard-units-location-sub-div">
                      <div className="infocard-component-togglebtn-div">
                        <div className="infocard-component-value-div">
                          <input
                            className="infocard-location-value text-truncate"
                            type="number"
                            value={pitchInput?.value}
                            title={pitchInput?.value}
                            onKeyDown={onKeyDown}
                            onChange={(e) => {
                              checkEmptyRollPitchYawValues("PitchInput");
                              validateAndSetRPYInput(e.target.value, "PitchInput")
                            }}
                          ></input>
                        </div>
                        <div className="infocard-component-units-div">
                          <span className="infocard-location-y-axis">{pitchInput?.unit}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="infocard-component-properties-div">
                  <div className="infocard-component-properties-sub-div">
                    <span className="infocard-units-location-span">{yawInput?.name}</span>
                    <div className="infocard-units-location-sub-div">
                      <div className="infocard-component-togglebtn-div">
                        <div className="infocard-component-value-div">
                          <input
                            className="infocard-location-value text-truncate"
                            type="number"
                            value={yawInput?.value}
                            title={yawInput?.value}
                            onKeyDown={onKeyDown}
                            onChange={(e) => {
                              checkEmptyRollPitchYawValues("YawInput");
                              validateAndSetRPYInput(e.target.value, "YawInput")
                            }}
                          ></input>
                        </div>
                        <div className="infocard-component-units-div">
                          <span className="infocard-location-y-axis">{yawInput?.unit}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </>
            )}

            {isVector && (
              <>
                <div className="infocard-units-location-value-div">
                  <span className="infocard-units-location-span">Pointing Entity</span>
                  <div style={{ minWidth: '140px' }}>
                    {pointingEntities.length > 1 ? (
                      <SatelliteProfileModalDropdown
                        options={pointingEntities}
                        isMulti={false}
                        handleSelectedOption={handleSelectedPointingEntity}
                        previousOption={isPreviousSelected}
                      />
                    ) : (
                      <span className="infocard-units-location-span pointing_vector">
                        {pointingEntities[0]?.value}
                      </span>
                    )}
                  </div>
                </div>
                <div className="infocard-units-location-value-div">
                  <span className="infocard-units-location-span">Pointing Vector</span>
                  <div className="infocard-three-inputs-div">
                    <div className="infocard-location-div infocard-location-div-reverse">
                      <div className="infocard-location-value-div">
                        <input
                          className="infocard-location-value text-truncate"
                          type="number"
                          value={orientation.x}
                          title={orientation.x.toString()}
                          onChange={(e) => {
                            const inputValue: String = e.target.value;
                            checkIfPointingVectorIsEmpty('x')
                            validateAndSetOrientationData(inputValue, 'x');
                          }}
                          disabled={name?.toLowerCase().includes('nadir')}
                        ></input>
                      </div>
                      <div className="infocard-location-x-axis-div">
                        <span className="infocard-location-x-axis">X</span>
                      </div>
                    </div>
                    <div className="infocard-location-div infocard-location-div-reverse">
                      <div className="infocard-location-value-div">
                        <input
                          className="infocard-location-value text-truncate"
                          type="number"
                          value={orientation.y}
                          title={orientation.y.toString()}
                          onChange={(e) => {
                            const inputValue: String = e.target.value;
                            checkIfPointingVectorIsEmpty('y')
                            validateAndSetOrientationData(inputValue, 'y');
                          }}
                          disabled={name?.toLowerCase().includes('nadir')}
                        ></input>
                      </div>
                      <div className="infocard-location-x-axis-div">
                        <span className="infocard-location-y-axis">Y</span>
                      </div>
                    </div>
                    <div className="infocard-location-div infocard-location-div-reverse">
                      <div className="infocard-location-value-div">
                        <input
                          className="infocard-location-value text-truncate"
                          type="number"
                          value={orientation.z}
                          title={orientation.z.toString()}
                          onChange={(e) => {
                            const inputValue: String = e.target.value;
                            checkIfPointingVectorIsEmpty('z')
                            validateAndSetOrientationData(inputValue, 'z');
                          }}
                          disabled={name?.toLowerCase().includes('nadir')}
                        ></input>
                      </div>
                      <div className="infocard-location-x-axis-div">
                        <span className="infocard-location-z-axis">Z</span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            <DividerLine/>
            <div className="customModelModalFooter">
              <button
                // disabling the button if any of the following input fields are empty for ADD and UPDATE both cases
                disabled={
                  (
                    !name ||
                    [rollInput.value, pitchInput.value, yawInput.value].some(
                      val => String(val).trim() === '' || isNaN(Number(val))
                    )
                     ||
                    [orientation.x, orientation.y, orientation.z].some(
                      val => val === '' || isNaN(Number(val))
                    )
                  ) ||
                  (prevControlmode && !isValueUpdate)
                }
                className="control-mode-btn"
                onClick={() => {
                  checkEmptyRollPitchYawValues("other")
                  addingControlMode()
                }}
              >
                {prevControlmode ? 'Update' : 'Add'}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SatDesignerBottomBarModal;
